var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c("base-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isRefreshing,
            expression: "isRefreshing",
          },
        ],
        ref: "baseTable",
        attrs: {
          "base-url": _vm.urlWithFilters,
          "element-loading-spinner": "el-icon-loading",
        },
        on: {
          "load-success": _vm.onLoadSuccess,
          "load-error": _vm.onLoadError,
          refresh: _vm.onRefresh,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "el-table",
                  {
                    staticClass: "w-100",
                    attrs: {
                      data: _vm.items,
                      stripe: "",
                      "summary-method": _vm.getTotals,
                      "show-summary": "",
                    },
                    on: { "sort-change": _vm.sortChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "expand" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row: { listUrl } }) {
                            return [
                              _c("expand-column", {
                                attrs: { url: listUrl, params: _vm.params },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "id",
                        sortable: "",
                        label: "Id",
                        "min-width": "80",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "Representative",
                        "min-width": "150",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "regular_messages",
                        label: "Messages",
                        "min-width": "100",
                        sortable: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "regular_contacts",
                        label: "Total Contacts",
                        "min-width": "100",
                        sortable: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "group_messages",
                        label: "Group Messages",
                        sortable: "",
                        "min-width": "100",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }